var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2259 2.52356C12.3947 4.23458 11.25 6.67111 11.25 9.37497C11.25 14.5526 15.4474 18.75 20.625 18.75C23.3289 18.75 25.7654 17.6054 27.4764 15.7741C27.0766 22.3171 21.6436 27.5 15 27.5C8.09644 27.5 2.5 21.9035 2.5 15C2.5 8.35641 7.68286 2.92335 14.2259 2.52356Z",
    fill: "#1D1E24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTheme);
export default __webpack_public_path__ + "static/media/dark-theme.d0ec871db704927fc517c0ed1783a86e.svg";
export { ForwardRef as ReactComponent };